export const StudioFlowColors = {
  primary: '#1D7A7A',
  primaryHover: '#186868',
  background: '#FFFFFF',
  surface: '#F7F8F9',
  title: '#010B2E',
  subtitle: '#4D546D',
  accent: '#B3B6C0',
  eyebrow: '#808596',
  border: '#808596',
  unfocused: '#D9DAE0',
  selectionStroke: '#F0F0F2',
  disabled: '#F0F0F2',
  disabledText: '#B3B6C0',
  displayFontFamily: '"VC Garamond Condensed", "Times New Roman", serif',
  bodyFontFamily: '"CircularXX", "Circular LL VIP", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

export const StudioFlowRadii = {
  input: 16,
  pill: 104,
  card: 32,
};
